<script lang="ts">
  import Loading from '../../etc/loader.svelte';
  import ModifySimChangeModal from '../../etc/modal/premium/ModifySimChangeModal.svelte';
  import ModifyStopResumeModal from '../../etc/modal/ModifyStopResumeModal.svelte';
  import { getContext } from 'svelte';
  import RepositoryFactory, { CONTRACT, SIM_EXCHANGE_DELIVERY, MNP } from '../../repositories/RepositoryFactory';
  import type { GetContractResult } from '../../repositories/contract';
  import { loginUser } from '../../components/auth/LoginUser';
  import { push } from 'svelte-spa-router';
  import { addDays, isAfter, parse } from 'date-fns';
  import { isAvailableMnpReserveNumberRequest } from '../../components/Util.svelte';

  const { open }: any = getContext('simple-modal');

  const showModifySimExchangeModal = () => {
    open(ModifySimChangeModal);
  };
  const showModifyStopResumeModal = () => {
    open(ModifyStopResumeModal);
  };

  let promise = getApi();
  let requestDate: string;
  let mnpNumberIssueStatus = '';
  async function getApi() {
    let contract: GetContractResult;
    const contractRepository = RepositoryFactory[CONTRACT];
    const simRepository = RepositoryFactory[SIM_EXCHANGE_DELIVERY];
    const mnpRepository = RepositoryFactory[MNP];

    await Promise.all([
      contractRepository.getContract(),
      simRepository.getSimExchangeDeliveryStatusForPremium(),
      mnpRepository.getMnpReserveNumberForPremium()
    ])
      .then((res) => {
        if (!res) {
          throw new Error();
        }
        contract = res[0];
        requestDate = res[1]?.registerDate;
        mnpNumberIssueStatus = res[2]?.issueStatusCode;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          push('/login');
          return false;
        } else {
          alert('エラーが発生しました。');
          throw new Error();
        }
      });
    return contract;
  }

  function isUnAvaiableSimExchange() {
    // MNP予約番号発行中はSIM再発行不可
    if (!isAvailableMnpReserveNumberRequest(mnpNumberIssueStatus)) {
      return true;
    }
    if (!requestDate) {
      return false;
    }
    // SIM交換依頼日 + 2 > 現在日
    let currentDate = new Date();
    return isAfter(addDays(parse(requestDate, 'yyyyMMdd', currentDate), 2), new Date());
  }
</script>

<!-- 本体 -->
{#await promise}
  <Loading />
{:then contract}
  <div class="flex mb-4">
    <div class="rounded bg-white border-t-4 border-green-400">
      <div class="shadow rounded-lg bg-gray-50 border-1 p-4 mb-10">
        <div class="flex flex-col divide-y divide-gray-300">
          <div class="flex-1 flex flex-col divide-y divide-gray-300 p-4">
            <div class="flex-1">
              <h4 class="text-lg font-semibold">一時停止・再開</h4>
            </div>
            <div class="flex-1">
              <div class="inline-grid md:grid-cols-3 justify-items-center items-center min-w-full p-4">
                <div class="grid-1 col-span-2 justify-self-start w-full">
                  <span class="">SIM一時停止・再開変更の手続きはこちら</span>
                </div>

                <div class="grid-1">
                  <button
                    on:click={showModifyStopResumeModal}
                    class="button-primary"
                    disabled={contract.contractStatusCode === 'TERMINATED'}
                  >
                    手続きへ
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-1 flex flex-col pt-20 divide-y divide-gray-300 p-4">
            <div class="flex-1">
              <h4 class="text-lg font-semibold">SIM交換</h4>
            </div>
            <div class="flex-1">
              <div class="inline-grid md:grid-cols-3 justify-items-center items-center min-w-full p-4">
                <div class="grid-1 col-span-2 justify-self-start w-full">
                  <span class="">SIM交換の手続きはこちら</span>
                </div>

                <div class="grid-1">
                  <button
                    on:click={showModifySimExchangeModal}
                    class="button-primary"
                    disabled={contract.contractStatusCode === 'TERMINATED' || isUnAvaiableSimExchange()}
                  >
                    手続きへ
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/await}

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default bg-gray-400;
  }
</style>
